import { render, staticRenderFns } from "./uploadMaterial.vue?vue&type=template&id=6707a54f&scoped=true&"
import script from "./uploadMaterial.vue?vue&type=script&lang=js&"
export * from "./uploadMaterial.vue?vue&type=script&lang=js&"
import style0 from "./uploadMaterial.vue?vue&type=style&index=0&id=6707a54f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6707a54f",
  null
  
)

export default component.exports